var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"roller observe",class:("roller-" + _vm.type)},_vm._l((_vm.count),function(i){return _c('div',[_c('div',{staticClass:"rotation"})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }